import React, { useContext, useEffect } from "react";
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import { CycleFilterContext } from "../overview/context/CycleFilterContext";
import { OverviewContext } from "../overview/context/OverviewContext";
import { FormattedMessage, injectIntl } from "react-intl";
import Row from "@amzn/meridian/row";
import Tooltip from "@amzn/meridian/tooltip";

const DNCView = (props) => {
  const { cycles } = useContext(CycleFilterContext);
  const { viewModel, dispatch } = useContext(OverviewContext);

  const getDNCData = () => {
    dispatch({
      type: "LOAD_DNC_DATA",
      data: { filter: cycles.selectedCycles, dispatcher: dispatch },
    });
  };

  useEffect(() => {
    if (cycles.allCycles.length > 0) {
      getDNCData();
      const interval = setInterval(() => {
        if (!document.hidden) {
          getDNCData();
        }
      }, props.compliance.refreshRate);
      return () => clearInterval(interval);
    }
  }, [cycles]);

  return (
    <div>
      <div className="overview-fph">
        <Heading level={2} type="h300" alignment="left">
          <Tooltip
            position="right"
            title={props.intl.formatMessage({
              id: viewModel.compliance[props.compliance.processName].tooltip,
              defaultMessage:
                viewModel.compliance[props.compliance.processName]
                  .tooltipMessage,
            })}
          >
            <FormattedMessage
              id={viewModel.compliance[props.compliance.processName].title}
              defaultMessage={
                viewModel.compliance[props.compliance.processName]
                  .defaultMessage
              }
            />
          </Tooltip>
        </Heading>
      </div>
      <Row width="100%" widths={["grid-12"]}>
        <div>
          <Text type="b100">
            <FormattedMessage id="fph.actual" defaultMessage="Actual" />
          </Text>
          <Text type="d50">{viewModel.compliance["dnc"].value}</Text>
        </div>
      </Row>
    </div>
  );
};

export default injectIntl(DNCView);



// WEBPACK FOOTER //
// ./src/components/dnc/DNCView.js